<template>
  <div class="header-bar w-full flex flex-row">
    <portal-target name="headerBreadCrumb"></portal-target>
    <div class="flex flex-grow justify-between relative">
      <div class="flex items-center text-sm pl-4 font-semibold">
        <span
          class="pr-4 flex items-center text-gray-700"
          data-scaleplus-launcher-anchor
        >
          {{ routeTitle }}
        </span>
        <span class="scaleplus-launcher-space" aria-hidden="true"></span>
      </div>
    </div>
    <portal-target name="headerContent"></portal-target>
  </div>
</template>
<script>
const LAUNCHER_SCRIPT_ID = 'scaleplus-app-launcher-script';

export default {
  name: "HeaderBar",

  props: ["routeTitle"],

  watch: {
    routeTitle() {
      this.$nextTick(() => window.dispatchEvent(new Event('resize')));
    },
  },

  data() {
    return {
      launcherInstance: null,
      launcherLoadHandler: null,
    };
  },

  mounted() {
    this.ensureScalePlusLauncher();
  },

  beforeDestroy() {
    const script = document.getElementById(LAUNCHER_SCRIPT_ID);
    if (script && this.launcherLoadHandler) {
      script.removeEventListener('load', this.launcherLoadHandler);
    }
    if (this.launcherInstance) {
      this.launcherInstance.destroy();
      if (window.scalePlusGrooveLauncher === this.launcherInstance) {
        window.scalePlusGrooveLauncher = null;
      }
    }
  },

  methods: {
    mountScalePlusLauncher() {
      if (!window.ScalePlusAppLauncher) return;

      if (window.scalePlusGrooveLauncher) {
        window.scalePlusGrooveLauncher.destroy();
      }

      this.launcherInstance = window.ScalePlusAppLauncher.mount({
        currentApp: 'groovecm',
        anchor: '[data-scaleplus-launcher-anchor]',
        navigation: 'direct',
        target: '_self',
        anchorGap: 10,
      });
      window.scalePlusGrooveLauncher = this.launcherInstance;
    },

    ensureScalePlusLauncher() {
      if (window.ScalePlusAppLauncher) {
        this.mountScalePlusLauncher();
        return;
      }

      let script = document.getElementById(LAUNCHER_SCRIPT_ID);
      this.launcherLoadHandler = () => this.mountScalePlusLauncher();

      if (!script) {
        script = document.createElement('script');
        script.id = LAUNCHER_SCRIPT_ID;
        script.src = 'https://app.scaleplus.gg/app-launcher.js';
        script.defer = true;
        script.dataset.autoMount = 'false';
        document.head.appendChild(script);
      }

      script.addEventListener('load', this.launcherLoadHandler, { once: true });
    },
  },
};
</script>

<style scoped>
.scaleplus-launcher-space {
  display: block;
  flex: 0 0 112px;
  width: 112px;
}

@media (max-width: 720px) {
  .scaleplus-launcher-space {
    flex-basis: 86px;
    width: 86px;
  }
}
</style>
